import AdminLayout from '../../layout/AdminLayout';

import * as Server from 'assets/js/Server';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useModal } from '../../hooks/modalContext';

export default function ShopifySales(){
  const { openModal } = useModal();

  const [orderList, setOrderList] = useState([]);

  const getOrderList = () => {
    Server.sendGet('shopify/order', {}, getOrderListCallback).then();
  }

  const getOrderListCallback = res => {
    setOrderList(res['resultList']);
  }

  const getOrderDetailList = () => {
    Server.sendGet('shopify/order/detail', {}, getOrderListCallback).then();
  }

  const getOrderDetailListCallback = res => {
    setOrderList(res['resultList']);
  }

  const handleAdd = shopifyOrderMstSeq => {
    openModal({
      modalName: 'TobOrderDetailModal',
      modalData: {
        isRegi: true,
        data: {
          item: {
            shopifyOrderMstSeq: shopifyOrderMstSeq
          },
          callback: {},
        },
      }
    });
  };

  useEffect(() => {
    getOrderList();
  }, [])

  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>Shopify Order Info</h4>
        </div>
      </div>
      <div className="content">
        <table className="admin-table">
          <thead>
          <tr>
            <th>Order Date</th>
            <th>Customer Username</th>
            <th>Customer Email</th>
            <th>Customer Mobile</th>
            <th>Order Amount</th>
            <th>Promo Code</th>
            <th>Order Id</th>
            <th>Order Details</th>
          </tr>
          </thead>
          <tbody>
          {orderList?.map((item, idx) => (
            <>
              <tr key={idx}>
                <td>{item.orderDate}</td>
                <td>{item.customerName}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.totalPrice}</td>
                <td>{item.discountCode}</td>
                <td>{item.orderId}</td>
                <td>
                  <Btn
                    onClick={() => handleAdd(item.shopifyOrderMstSeq)}
                  > View </Btn>
                </td>
              </tr>
            </>
          ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  )
}

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : (props.$Delete ? '#FF4848' : '#a4a4a4'))};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : (props.$Delete ? '#FF2424' : '#7e7e7e'))};
  }
`;
